import { action, observable, makeObservable, runInAction } from "mobx";
import api from "../../../../api";
import { message } from "antd";
import CommonStore from "../../common_store";
import axios from "axios";

class MyApplicationStore {
  @observable searchFormModal: any = {};
  //搜索表单字段
  @observable searchForm: any = {};
  @observable applySearchForm: any = {};
  @observable tableData: any = {};

  // X池读的权限
  @observable getAllXPoolReadInfo: any = [];
  // X池编辑的权限
  @observable getAllXPoolWriteInfo: any = [];

  //新增X号
  @observable addNumberModal: boolean = false;
  //按钮的loading状态
  @observable buttonLoading: boolean = false;
  //报备书文件
  @observable formData: any = null;
  //申请附件
  @observable applyFormData: any = null;
  //申请预览数据
  @observable applyPreviewData: any = {};
  //申请预览弹框
  @observable applyPreviewModal: boolean = false;
  //申请预览提交按钮
  @observable applyPreviewButtonLoading: boolean = false;
  @observable applyPreviewTableLoading: boolean = false;
  //批量新增传的号池id
  @observable xpoolNo: any = "";
  @observable spinning: boolean = false;
  //预览搜索表单字段
  @observable tableDataModal: any = {};
  //新增批次号
  @observable batchNumber: string = "";
  // @observable checkedList: CheckboxValueType[] = [];
  @observable checkedList: string[] = [];
  //预览数据错误类型统计
  @observable previewCountData: any = {};
  //错误类型下载
  @observable exportErrorFlag: boolean = false;
  //控制预览弹框提交按钮
  @observable allowSubmit: boolean = false;
  @observable templateModal: boolean = false;
  //是否上传报备书文件
  @observable approval: boolean = false;
  //预览的分页信息
  @observable pageDataModal: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageDataModal.page = page;
        this.pageDataModal.size = size;
        this.pageDataModal = { ...this.pageDataModal };
      });
      this.previewPage(this.batchNumber);
    },
  };

  //虚拟运营商列表
  @observable virtualCarrier: any = [];
  //省市列表
  @observable provinceCityCode: any = [];

  //申请X号
  @observable applyNumberModal: boolean = false;
  @observable ApplicationtableLoad: boolean = false;
  //申请详情分页信息
  @observable ApplicationpageDataModal: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.ApplicationpageDataModal.page = page;
        this.ApplicationpageDataModal.size = size;
        this.ApplicationpageDataModal = { ...this.ApplicationpageDataModal };
      });
      this.applicationSelfDetailPage();
    },
  };
  //申请详情
  @observable applyDetail: any = {};
  //存储申请记录对应的申请数据
  @observable detailData: any = {};
  //控制申请详情弹框
  @observable applicationModal: any = {
    title: "申请详情",
    add: false,
    apply: false,
    get isOpen(): boolean {
      return (
        this.add ||
        this.apply ||
        this.updateGeneralConfig ||
        this.updateEditIsEnable
      );
    },
    open: (type: "add" | "apply", data: any) => {
      runInAction(() => {
        this.detailData = data;
        this.ApplicationpageDataModal.page = 1;
        this.ApplicationtableLoad = true;
      });

      if (type === "add") {
        runInAction(() => {
          this.applicationModal.add = true;
          this.applicationModal.apply = false;
        });

        const data: any = {};
        data.size = this.ApplicationpageDataModal.size;
        data.page = this.ApplicationpageDataModal.page;
        data.no = this.detailData.no;
        api.MyApplicationApi.getApplicationSelfDetail(data)
          .then((res) => {
            runInAction(() => {
              this.applyDetail = { ...res.data };
              this.ApplicationtableLoad = false;
            });
          })
          .catch((e) => {
            runInAction(() => {
              this.ApplicationtableLoad = false;
            });
          });
      } else if (type === "apply") {
        runInAction(() => {
          this.applicationModal.add = false;
          this.applicationModal.apply = true;
        });

        api.MyApplicationApi.getApplicationDetail(data.no)
          .then((res) => {
            runInAction(() => {
              this.applyDetail = { ...res.data };
              this.applyDetail?.xpoolApplicationDetails?.forEach(
                (item: any, index: number) => {
                  item.order = index + 1;
                }
              );
              this.ApplicationtableLoad = false;
            });
          })
          .catch((e) => {
            runInAction(() => {
              this.ApplicationtableLoad = false;
            });
          });
      }
    },
    close: () => {
      runInAction(() => {
        this.applicationModal.add = false;
        this.applicationModal.apply = false;
        this.applyDetail = {};
        this.detailData = {};
      });
    },
  };

  @observable tableApprovalData: any = {};
  @observable tableApplicationData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.applyPage();
    },
  };

  //控制审批详情弹框
  @observable approvalModal: boolean = false;
  @observable applyNo: string = "";
  //申请类型
  @observable applyType: string = "";
  //导出号码列表
  @observable numberList: any = [];

  commonStore: CommonStore;

  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  setApplySearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.applySearchForm = obj;
    });
  }

  setSearchModalForm(obj: any) {
    runInAction(() => {
      this.searchFormModal = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
      this.pageDataModal.page = 1;
    });
  }

  @action
  getProvinceCityList() {
    api.MyApplicationApi.getProvinceCityCodes()
      .then((res: any) => {
        runInAction(() => {
          this.provinceCityCode = [...res.data];
        });
      })
      .catch((e: any) => {});
  }

  getVirtualCarrierList() {
    api.MyApplicationApi.getByType({ dictionaryType: "virtualCarrier" })
      .then((res: any) => {
        runInAction(() => {
          this.virtualCarrier = [...res.data];
        });
      })
      .catch((e: any) => {});
  }

  //获取捞号申请详情
  @action
  applicationSelfDetailPage() {
    const data: any = {};
    data.size = this.ApplicationpageDataModal.size;
    data.page = this.ApplicationpageDataModal.page;
    data.no = this.detailData.no;
    api.MyApplicationApi.getApplicationSelfDetail(data).then((res) => {
      runInAction(() => {
        this.applyDetail = { ...res.data };
      });
    });
  }

  @action
  applyPage() {
    if (this.searchForm.applicationTime) {
      this.searchForm.applicationTimeEnd =
        this.searchForm.applicationTime[1].format("YYYY-MM-DD HH:mm:ss");
      this.searchForm.applicationTimeStart =
        this.searchForm.applicationTime[0].format("YYYY-MM-DD HH:mm:ss");
    }
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.MyApplicationApi.applyPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("xpool_apply_management");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  @action
  ApplicationDataPage(record?: any) {
    runInAction(() => {
      this.tableApplicationData = {};
      this.ApplicationtableLoad = true;
      this.applyNo = record ? record.no : this.applyNo;
      this.applyType = record ? record.applyType : this.applyType;
    });
    const data = { ...this.searchFormModal };
    data.size = this.pageDataModal.size;
    data.page = this.pageDataModal.page;
    data.applyNo = this.applyNo;

    api.MyApplicationApi.getApplyDetail(data)
      .then((res: any) => {
        console.log(this.applyNo);
        runInAction(() => {
          this.tableApplicationData = res.data;
          this.tableApplicationData = { ...this.tableApplicationData };
          this.ApplicationtableLoad = false;
        });
      })
      .catch((e: any) => {
        runInAction(() => {
          this.ApplicationtableLoad = false;
        });
      });
  }

  @action
  controlApproval() {
    runInAction(() => {
      this.approvalModal = false;
    });
  }

  //获取X池号码报备书的临时下载地址
  getPreSignedUrl(name: string, type: string) {
    api.MyApplicationApi.getPreSignedUrl(name)
      .then((res: any) => {
        window.open(res.data, "_blank");
      })
      .catch((e: any) => {});
  }

  //下载号码文件
  exportNumber(applicationNo: string) {
    api.MyApplicationApi.exportApplicationNumber({
      applicationNo: applicationNo,
    })
      .then(async (res: any) => {
        message.success("号码文件导出成功");
      })
      .catch((err: any) => {
        const blob = new Blob([err], {
          type: "application/vnd.ms-excel",
        });
        if ("download" in document.createElement("a")) {
          // 生成<a></a >DOM元素
          const link = document.createElement("a");
          link.download = "号码文件.xlsx";
          link.style.display = "none";
          // a标签的href属性指定下载链接
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          // 必须点击否则不会下载
          link.click();
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link);
        }
      });
  }

  //查询当前账户全部x池
  @action
  getAllXPool(data: number) {
    api.xNumberManageApi
      .getAllXPool(data)
      .then(async (res: any) => {
        if (data === 0) {
          runInAction(() => {
            this.getAllXPoolReadInfo = res.data;
          });
        } else {
          runInAction(() => {
            this.getAllXPoolWriteInfo = res.data;
          });
        }
      })
      .catch((e: any) => {});
  }

  //批量新增弹框上传号码文件
  @action controlAdd = (data?: any) => {
    this.getAllXPool(1);
    runInAction(() => {
      this.addNumberModal = !this.addNumberModal;
      this.formData = null;
      this.xpoolNo = "";
    });
  };

  //批量新增 X池号码预览
  @action
  addPreview(info: any) {
    const formData = new FormData();
    formData.append("file", info.file as any);
    api.MyApplicationApi.addPreview(this.xpoolNo, formData)
      .then(async (previewRes: any) => {
        runInAction(() => {
          this.batchNumber = previewRes.data.batchNumber;
          this.exportErrorFlag = previewRes.data.exportErrorFlag;
          this.templateModal = true;
          this.spinning = false;
        });
        this.previewPage(this.batchNumber);
        this.previewCount();
      })
      .catch((e: any) => {
        runInAction(() => {
          this.spinning = false;
        });
      });
  }

  //预览数据分页查询
  @action
  previewPage(batchNumber?: string) {
    runInAction(() => {
      this.tableDataModal = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchFormModal };
    data.size = this.pageDataModal.size;
    data.page = this.pageDataModal.page;
    data.batchNumber = batchNumber ? batchNumber : this.batchNumber;
    data.xpoolNo = this.xpoolNo;
    api.MyApplicationApi.previewPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableDataModal = res.data;
            this.tableDataModal = { ...this.tableDataModal };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  //预览数据错误类型统计
  @action
  previewCount() {
    api.MyApplicationApi.previewCount(this.batchNumber)
      .then((res: any) => {
        runInAction(() => {
          this.previewCountData = res.data;
        });
        this.changeCheckList([]);
      })
      .catch((e: any) => {});
  }

  //申请号码预览
  @action
  submitApplyNumberPreviw(data: any) {
    this.buttonLoading = true;
    const formData = new FormData();
    formData.append("xpoolNo", data.xpoolNo);
    formData.append("vnoId", data.vnoId);
    if (this.applyFormData)
      formData.append("file", this.applyFormData.file as any);
    if (data.applicationDetails) {
      data.applicationDetails.forEach((item: any, index: number) => {
        item.provinceCode = item.provinceCityCode[0];
        item.cityCode = item.provinceCityCode[1];
      });
      formData.append(
        "applicationDetailsJson",
        JSON.stringify(data.applicationDetails)
      );
    }
    if (data.speechRange) formData.append("speechRange", data.speechRange);
    if (data.speechScene) formData.append("speechScene", data.speechScene);
    if (data.expectedRatio)
      formData.append("expectedRatio", data.expectedRatio.toString());
    if (data.complaintLimit)
      formData.append("complaintLimit", data.complaintLimit.toString());
    api.MyApplicationApi.xNumberApplyPreview(formData)
      .then((res: any) => {
        if (res.code == 200) {
          this.applyPreviewModal = true;
          this.applyPreviewTableLoading = true;
          this.applyPreviewData = res.data;
          this.applyPreviewData.applicationDetails.forEach(
            (item: any, index: number) => {
              item.order = index + 1;
            }
          );
          this.applyPreviewTableLoading = false;
        }
      })
      .catch((e: any) => {})
      .finally(() => {
        this.buttonLoading = false;
      });
  }

  submitApplyNumber() {
    this.applyPreviewButtonLoading = true;
    api.MyApplicationApi.xNumberApply(this.applyPreviewData)
      .then((res: any) => {
        if (res.code == 200) {
          message.success("申请已提交");
          this.resetPage();
          this.applyPage();
          this.applyPreviewModal = false;
          this.applyNumberModal = false;
        }
      })
      .catch((e: any) => {})
      .finally(() => {
        this.applyPreviewButtonLoading = false;
      });
  }

  @action changeCheckList(list: string[]) {
    this.checkedList = [...list];
    let newpreviewCountData = { ...this.previewCountData };
    delete newpreviewCountData.total;
    this.checkedList.forEach((item: any) => {
      if (
        item === "poolRepeat" ||
        item === "tableRepeat" ||
        item === "numberNotExist" ||
        item === "otherError"
      ) {
        delete newpreviewCountData[item];
      }
    });
    let sum = 0;
    let arr: any = Object.values(newpreviewCountData);
    for (var i = arr.length - 1; i >= 0; i--) {
      sum += arr[i];
    }
    if (
      this.previewCountData.total ===
      this.previewCountData.poolRepeat +
        this.previewCountData.tableRepeat +
        this.previewCountData.numberNotExist +
        this.previewCountData.otherError
    ) {
      runInAction(() => {
        this.allowSubmit = true;
      });
    } else {
      runInAction(() => {
        this.allowSubmit = !Boolean(sum === 0);
      });
    }
  }

  //错误数据导出
  @action
  exportError() {
    api.MyApplicationApi.exportError({ batchNumber: this.batchNumber })
      .then(async (res: any) => {
        message.success("错误数据导出成功");
      })
      .catch((err: any) => {
        const blob = new Blob([err], {
          type: "application/vnd.ms-excel",
        });
        if ("download" in document.createElement("a")) {
          // 生成<a></a >DOM元素
          const link = document.createElement("a");
          link.download = "错误数据导出.xlsx";
          link.style.display = "none";
          // a标签的href属性指定下载链接
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          // 必须点击否则不会下载
          link.click();
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link);
        }
      });
  }

  //取消新增预览弹框
  @action cancelPreview = (data?: any) => {
    runInAction(() => {
      this.templateModal = false;
      this.searchFormModal = {};
      this.approval = false;
    });
    this.resetPage();
  };
  //取消申请预览弹框
  @action cancelApplyPreview = () => {
    runInAction(() => {
      this.applyPreviewModal = false;
      this.applyPreviewData = {};
    });
  };

  //预览页面新增号码申请
  @action
  submitAddNumber(info: any) {
    runInAction(() => {
      this.tableLoad = true;
      this.buttonLoading = true;
    });
    api.MyApplicationApi.preSignedPut({ fileName: info.file.name }).then(
      (res: any) => {
        if (res.code == 200) {
          axios
            .put(res.data.urlPath, info.file, {
              headers: { "Content-Type": "application/pdf" },
              withCredentials: false,
            })
            .then((response) => {})
            .catch((err) => {});
          api.MyApplicationApi.xNumberAdd({
            batchNumber: this.batchNumber,
            objectName: res.data.objectName,
            xpoolNo: this.xpoolNo,
          })
            .then(async (res: any) => {
              runInAction(() => {
                this.templateModal = false;
                this.searchFormModal = {};
                this.approval = false;
                this.tableLoad = false;
                this.buttonLoading = false;
              });
              message.success("已提交申请");
              this.resetPage();
              this.applyPage();
            })
            .catch((e: any) => {});
        }
      }
    );
  }

  //控制申请弹框
  @action
  controlApply() {
    this.getAllXPool(1);
    runInAction(() => {
      this.applyNumberModal = !this.applyNumberModal;
    });
  }
}

export default MyApplicationStore;
